<script>
    // -- IMPORTS
    import { clickOutside } from "$src/lib/base";
    import { enabledAdminView } from "$src/lib/store/adminStore";
    import { slide } from "svelte/transition";
    import BlockList from "./BlockList.svelte";
    import Button from "./Button.svelte";
    import Modal from "../../../../../ADMIN/src/lib/component/element/Modal.svelte";
    import AddManagerPage from '../../../../../ADMIN/src/lib/page/manager/AddManagerPage.svelte';
    import NewBlock from "../../../../../ADMIN/src/lib/component/element/NewBlock.svelte";
    import ElementList from "./ElementList.svelte";

    // -- VARIABLES
    let { 
        blockArray = $bindable([]),
        pageId = '',
        pageWithBlocks = true,
        isManager = false
    } = $props();

    let isModalOpen = $state( false );
    let isAddBlockModalOpen = $state( false );
    let isAddManagerModalOpen = $state( false );

    let blockData = {
        id : '',
        slug : 'new',
        typeSlug : 'text-and-media',
        number : 0,
        isActive : true,
        title : '',
        text : '',
        textArray: [],
        subTitle : '',
        description : '',
        mediaPath : '',
        mediaPathArray : [],
        imageAlt : '',
        imagFit : '',
        imageHorizontalPosition : '',
        imageVerticalPosition : '',
        imageSide: 'right',
        imageLegend: ''
    };

    // -- FUNCTIONS

    function handleOpenModal(
        )
    {
        isModalOpen = true;
    }

    // ~~

    function handleCloseModal(
        )
    {
        isModalOpen = false;
    }

    // ~~

    function handleOpenAddBlockModal(
        )
    {
        isModalOpen = false;
        isAddBlockModalOpen = true;
    }

    // ~~

    function onBlockCreated(
        )
    {
        isAddBlockModalOpen = false;
        window.location.reload();
    }

    // ~~

    function handleOpenAddManagerModal(
        )
    {
        isModalOpen = false;
        isAddManagerModalOpen = true;
    }
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .button-container
    {
        position: fixed;
        top: 90vh;
        left: 1%;
        z-index: 1000;
    }

    .sortable-modal-header
    {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;

        display: flex;
        align-items: center;
        justify-content: space-between;

        width: 39.2%;
        padding: 1.5rem 3rem;

        box-shadow: 0px -2px 2px darkGreyColor;
        background: darkGrayColor;
    }

    .modal-title
    {
        font-size: 2.5rem;
    }

    .sortable-modal
    {
        overflow: scroll;
        position: fixed;
        z-index: 1000;
        left: 0;
        top: 0;

        width: 40%;

        display: flex;
        justify-content: center;
        align-items: center;

        background-color: darkGrayColor;
    }

    .empty-sortable-container
    {
        padding: 3rem;
        width: 100%;
        height: 100vh;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .sortable-modal-footer
    {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 9999;

        display: flex;
        align-items: center;
        justify-content: center;

        width: 39.2%;
        padding: 1.5rem 0;

        box-shadow: 0px -2px 2px darkGreyColor;
        background: darkGrayColor;
    }

    .add-block-button
    {
        min-width: 10.6125rem;
        border: 1px solid lightGoldColor;
        border-radius: 4px;
        padding: 0.75rem 1.25rem;

        display: flex;
        gap: 1rem;
        justify-content: center;
        align-items: center;

        background-color: darkGreyColor;

        font-size: 1rem;
        text-transform: uppercase;
        color: lightGoldColor;

        cursor: pointer;
        text-wrap: nowrap;
        width: fit-content;

        transition: all 0.2s ease-in-out;

        +media( smaller-desktop )
        {
            width: 100%;
            max-width: unset;
        }
    }

    .add-block-button:hover,
    .add-block-button:focus
    {
        background-color: lightGoldColor;

        color: darkGreyColor;
    }

    .add-block-button:hover .light-gold-plus-icon
    {
        background-color: darkGreyColor;

        transition: background-color .3s ease-in-out;
    }

    .light-gold-chevron-down-icon
    {
        transform: rotate( 270deg );
    }

    .button-container:hover .light-gold-chevron-down-icon
    {
        background-color: darkGreyColor;

        transition: background-color .2s ease-in-out;
    }
</style>

{#if $enabledAdminView}
    <Modal
        bind:showModal={ isAddBlockModalOpen }
        modalConfirmButtonLabel="Save"
        modalType=""
        hasFooterButtons={ false }
        modalTitle="Add Block"
    >
        <NewBlock
            pageId={ pageId }
            blockData={ blockData }
            isManager={ false }
            onBlockCreated={ onBlockCreated }
        />
    </Modal>

    <Modal
        bind:showModal={ isAddManagerModalOpen }
        modalConfirmButtonLabel="Save"
        modalType=""
        hasFooterButtons={ false }
        modalTitle="Add Manager"
    >
        <AddManagerPage />
    </Modal>

    <div class="button-container">
        <Button
            onClick={ handleOpenModal }
        >
            {#if isManager}
                MANAGE AMBASSADORS
            {:else}
                MANAGE PAGE BLOCKS
            {/if}
            <div class="light-gold-chevron-down-icon size-200"></div>                        
        </Button>
    </div>
    
    {#if isModalOpen}
        <div class="sortable-modal-header" transition:slide="{{ axis: "x" }}">
            <h2 class="modal-title">Manage Blocks</h2>

            <Button onClick={ handleCloseModal } leftIconName="x" iconSize="250" size="compact">
            </Button>
        </div>

        <div 
            class="sortable-modal"
            onclickOutside={() => isModalOpen = false}
            transition:slide="{{ axis: "x" }}"
            use:clickOutside
        >
            {#if blockArray.length > 0}
                {#if pageWithBlocks}
                    <BlockList
                        bind:blockGroup={ blockArray }
                    />
                {:else}
                    <ElementList
                        bind:blockGroup={ blockArray }
                    />
                {/if}
            {:else}
                <div class="empty-sortable-container">
                    <h2>Looks like you didn't add any block here</h2>
                </div>
            {/if}

            <div class="sortable-modal-footer" transition:slide="{{ axis: "x" }}">
                <button
                    onclick={ isManager ? handleOpenAddManagerModal : handleOpenAddBlockModal }
                    class="add-block-button"
                    style="inset: 20px;"
                    title={ 'Add new' }
                >          
                    <div class="light-gold-plus-icon size-150"></div>

                    {#if isManager}
                        <span>ADD AMBASSADOR</span>
                    {:else}
                        <span>ADD NEW</span>
                    {/if}
                </button>
            </div>
        </div>
    {/if}
{/if}